interface InfoModalProps {
  isOpen: boolean
  onClose: () => void
}

export default function InfoModal({ isOpen, onClose }: InfoModalProps) {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Card */}
      <div
        className="relative flex flex-col items-center"
        style={{
          width: 315,
          background: '#282E44',
          border: '5px solid #060812',
          borderRadius: 18,
          paddingTop: 40,
          paddingBottom: 20,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ===== Title banner "INFO" — positioned at top, overlapping border ===== */}
        <div
          className="absolute flex flex-col items-center"
          style={{ top: -30, width: 199 }}
        >
          {/* Gold background bar */}
          <div
            style={{
              width: 199,
              height: 48,
              background: 'linear-gradient(180deg, #FAE045 0%, #F6C638 100%)',
              boxShadow:
                'inset -9px 0px 0px rgba(201, 50, 21, 0.5), inset 9px 0px 0px rgba(201, 50, 21, 0.5), inset 0px 4px 0px #FEF99D, inset 0px -2px 0px #FED751',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {/* "INFO" gradient text */}
            <span
              style={{
                fontFamily: "'Caesar Dressing', cursive",
                fontWeight: 400,
                fontSize: 37,
                lineHeight: '91.8%',
                background: 'linear-gradient(180deg, #EB441C 0%, #A52A1F 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                /* text-shadow doesn't work with gradient text, use filter instead */
                filter: 'drop-shadow(0px 2px 0px #FEE68F)',
              }}
            >
              Info
            </span>
          </div>
          {/* Bottom brown bar */}
          <div
            style={{
              width: 199,
              height: 7,
              background: 'linear-gradient(180deg, #CD7821 0%, #B1581C 100%)',
              boxShadow:
                'inset -9px 0px 0px rgba(201, 50, 21, 0.5), inset 9px 0px 0px rgba(201, 50, 21, 0.5)',
            }}
          />
        </div>

        {/* ===== Body text ===== */}
        <div
          style={{
            width: 271,
            marginTop: 20,
            fontFamily: 'Arial, sans-serif',
            fontWeight: 400,
            fontSize: 14,
            lineHeight: '150%',
            color: '#F8DDCA',
          }}
        >
          <p style={{ marginBottom: 12 }}>
            1. Select your bet → BET IN.
          </p>
          <p style={{ marginBottom: 12 }}>
            2. Press DROP at the right moment to place the roll accurately—the odds depend on your accuracy (0.1x–2.0x).
          </p>
          <p style={{ marginBottom: 12 }}>
            3. Take your winnings CASH OUT or continue building your tower.
          </p>
          <p style={{ marginBottom: 12 }}>
            4. Bonuses: HOT ROLLS and the gold line double your multipliers!
          </p>
          <p>
            5. The game ends if your WIN drops to 0 during the round.
          </p>
        </div>

        {/* ===== Close button ===== */}
        <button
          onClick={onClose}
          style={{
            width: 188,
            height: 40,
            marginTop: 16,
            background: '#DC3F48',
            boxShadow:
              'inset 0px -3px 0px #AA2930, inset 0px 2px 0px rgba(255, 119, 119, 0.25)',
            borderRadius: 7,
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: "'Big Shoulders Display', sans-serif",
            fontWeight: 700,
            fontSize: 20,
            lineHeight: '91.8%',
            textTransform: 'uppercase' as const,
            color: '#F8DDCA',
          }}
        >
          Close
        </button>
      </div>
    </div>
  )
}










